
























































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { storePernyataanKronologi } from "@/store/modules/PernyataanKronologiStore";
import PernyataanKronologiSvc from "@/services/PernyataanKronologi";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPernyataanKronologi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("pernyataan_kronologi", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("pernyataan_kronologi", "edit");
  }

  showForm = false;
  editingId: number | null = null;
  saving = false;
  formValid = false;
  expanded: any[] = [];

  hubunganOptions = [
    "Diri sendiri",
    "Suami",
    "Istri",
    "Anak",
    "Ayah",
    "Ibu",
    "Saudara Kandung"
  ];

  hariNames = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];

  tableHeaders = [
    { text: "No", value: "index", sortable: false, width: "50px" },
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "110px" },
    { text: "Pembuat", value: "pembuat_nama" },
    { text: "Hubungan", value: "hubungan_pasien", width: "120px" },
    { text: "Signed", value: "signed", width: "70px", align: "center" },
    { text: "Aksi", value: "actions", sortable: false, width: "160px" },
    { text: "", value: "data-table-expand" },
  ];

  nikRules = [
    v => !v || v.length === 16 || "NIK harus 16 digit"
  ];

  onDigitOnlyKeypress(e: KeyboardEvent) {
    if (e.key && e.key.length === 1 && !/\d/.test(e.key)) {
      e.preventDefault();
    }
  }

  onDigitOnlyPaste(e: ClipboardEvent) {
    const data = e.clipboardData ? e.clipboardData.getData("text") : "";
    if (data && /\D/.test(data)) {
      e.preventDefault();
      const cleaned = data.replace(/\D/g, "");
      if (cleaned) {
        document.execCommand("insertText", false, cleaned);
      }
    }
  }

  form: any = this.getEmptyForm();

  mounted() {
    storePernyataanKronologi.getByRegister(this.register);
  }

  getEmptyForm() {
    const today = localISODate();
    return {
      pembuat_nama: "",
      pembuat_tgl_lahir: "",
      pembuat_jenis_kelamin: "",
      pembuat_alamat: "",
      pembuat_nik: "",
      pembuat_no_hp: "",
      hubungan_pasien: "",
      kronologi_narasi: "",
      kejadian_hari: "",
      kejadian_tanggal: "",
      kejadian_pukul: "",
      kejadian_tempat: "",
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: today
    };
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get stateItems() {
    return storePernyataanKronologi.items.map((item, idx) => ({
      ...item,
      index: idx + 1
    }));
  }

  get stateLoading() {
    return storePernyataanKronologi.loading;
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  truncateNarasi(text: string) {
    if (!text) return "";
    return text.length > 200 ? text.substring(0, 200) + "..." : text;
  }

  onHubunganChange(val: string) {
    if (val === "Diri sendiri" && this.statePasien) {
      this.form.pembuat_nama = this.statePasien.nama || "";
      this.form.pembuat_tgl_lahir = this.statePasien.tgl_lahir || "";
      this.form.pembuat_jenis_kelamin = this.statePasien.jk === "Laki-laki" ? "L" : "P";
      this.form.pembuat_alamat = this.statePasien.alamat || "";
    }
  }

  onTanggalKejadianChange(val: string) {
    if (val) {
      const d = new Date(val + "T00:00:00");
      this.form.kejadian_hari = this.hariNames[d.getDay()] || "";
    } else {
      this.form.kejadian_hari = "";
    }
  }

  openForm() {
    this.editingId = null;
    this.form = this.getEmptyForm();
    this.showForm = true;
  }

  cancelForm() {
    this.showForm = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  editItem(item: any) {
    this.editingId = item.id;
    this.form = {
      pembuat_nama: item.pembuat_nama || "",
      pembuat_tgl_lahir: item.pembuat_tgl_lahir || "",
      pembuat_jenis_kelamin: item.pembuat_jenis_kelamin || "",
      pembuat_alamat: item.pembuat_alamat || "",
      pembuat_nik: item.pembuat_nik || "",
      pembuat_no_hp: item.pembuat_no_hp || "",
      hubungan_pasien: item.hubungan_pasien || "",
      kronologi_narasi: item.kronologi_narasi || "",
      kejadian_hari: item.kejadian_hari || "",
      kejadian_tanggal: item.kejadian_tanggal || "",
      kejadian_pukul: item.kejadian_pukul ? item.kejadian_pukul.substring(0, 5) : "",
      kejadian_tempat: item.kejadian_tempat || "",
      tempat_tanda_tangan: item.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: item.tgl_tanda_tangan || ""
    };
    this.showForm = true;
  }

  async simpan() {
    if (!(this.$refs.formPernyataan as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        pembuat_nik: this.form.pembuat_nik || null,
        pembuat_no_hp: this.form.pembuat_no_hp || null,
        kejadian_pukul: this.form.kejadian_pukul || null
      };

      let resp;
      if (this.editingId) {
        resp = await PernyataanKronologiSvc.update(this.editingId, payload);
      } else {
        resp = await PernyataanKronologiSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Pernyataan kronologi berhasil disimpan");
        this.cancelForm();
        storePernyataanKronologi.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async signItem(item: any) {
    const q = confirm("Tandatangani pernyataan kronologi ini? Setelah ditandatangani, data tidak dapat diubah atau dihapus.");

    if (q) {
      try {
        const resp = await PernyataanKronologiSvc.sign(item.id);
        if (resp.data.status == "1") {
          appModule.NoticeDelay("Berhasil menandatangani pernyataan kronologi");
          storePernyataanKronologi.getByRegister(this.register);
        }
      } catch {
        // Error sudah ditangani oleh service
      }
    }
  }

  async removeItem(item: any) {
    const q = confirm("Anda yakin akan menghapus pernyataan kronologi ini?");

    if (q) {
      try {
        const resp = await PernyataanKronologiSvc.destroy(item.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storePernyataanKronologi.getByRegister(this.register);
        }
      } catch {
        // Error sudah ditangani oleh service
      }
    }
  }

  printItem(item: any) {
    PernyataanKronologiSvc.print(item.id);
  }
}
